const styles = theme => ({
    fullscreen: {
        background: theme.palette.background.surface
    },
    dialog: {
        background: theme.palette.background.paper
    }
});

export default styles;